import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

const DeleteProductModal = ({ isOpen, onConfirm, onCancel, deleteProduct }) => {
  return (
    <Modal isOpen={isOpen}>
      <ModalHeader>
        {deleteProduct !== '' ? `Delete Product Group?` : `Delete Product?`}{' '}
      </ModalHeader>
      <ModalBody>
        {deleteProduct !== '' ? (
          'Do you really want to delete the product group?'
        ) : (
          <>
            Do you really want to delete the product? <br />
            <p style={{ fontSize: '10px', fontWeight: '800' }}>
              Changes will be applied after clicking on update.
            </p>
          </>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" outline onClick={onCancel}>
          No
        </Button>
        <Button color="primary" onClick={onConfirm}>
          Yes
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteProductModal;
